"use client"
import { StarRating } from "@/components/atoms"
import { SellerAvatar } from "@/components/cells/SellerAvatar/SellerAvatar"
import { SellerProps } from "@/types/seller"
import { SellerReview } from "../SellerReview/SellerReview"
import { format } from "date-fns"
import { useTranslate } from "@tolgee/react"

export const SellerInfo = ({
  seller,
  header = false,
}: {
  seller: SellerProps
  header?: boolean
}) => {
  const { t } = useTranslate()
  const { photo, name, description, created_at, reviews, summary } = seller
  const reviewCount = summary?.review_count || 0
  const rating = summary?.rating_avg || 0
  const toShowReviews = reviews
              ?.filter((rev) => rev !== null)
              .slice(-3) || []

  return (
    <div className="flex gap-4 w-full">
      <div className="relative shrink-0 size-14 overflow-hidden rounded-[12px]">
        <SellerAvatar photo={photo} size={56} alt={name} />
      </div>
      <div className="flex flex-col flex-1 min-w-0">
        <p className="font-semibold text-[15px] leading-[18.75px] text-[#101828]">{name}</p>
        <div className={"flex items-center gap-1.5 pt-0.5" + (toShowReviews.length > 0 ? " border-b pb-4" : "")}>
          <StarRating starSize={12} rate={rating || 5} />
          <span className="text-[11px] text-[#99a1af]">{reviewCount} {t("seller_info.reviews")}</span>
        </div>
        {header && (
          <>
            {description && (
              <p
                dangerouslySetInnerHTML={{ __html: description }}
                className="pt-1.5 text-[11px] leading-[17.875px] text-[#6a7282]"
              />
            )}
            {created_at && (
              <p className="pt-1 text-[11px] leading-[15.714px] text-[#4a5565]">
                {t("seller_footer.joined")} {format(created_at, "yyyy-MM-dd")}
              </p>
            )}
          </>
        )}
        <div className="mt-4">
          {!header && toShowReviews.map((review) => (
                <SellerReview key={review.id} review={review} />
              ))}
        </div>
      </div>
    </div>
  )
}
